/**
 * Embed close handshake (ADR-0004 / widget spec §4). In the widget modal the LAUNCHER owns the
 * chrome + close — its ✕ / scrim-click / Esc all post `towndesk:request-close` to this iframe and
 * wait for a `towndesk:close-check` reply before tearing the modal down. Every embeddable surface
 * must answer that message or the launcher's close controls do nothing (the dead-outer-✕ bug).
 *
 * `dirty` rides back on the reply so the launcher can confirm "Discard…?" before dropping unsaved
 * form state. Pages with nothing to lose (browse/landing/confirmation) omit it → the modal closes
 * immediately. No-op outside an embed (`embed === false`) — standalone pages have real browser
 * chrome and never receive the message.
 */
import { useEffect } from "react";

export function useEmbedClose(embed: boolean, dirty = false): void {
  useEffect(() => {
    if (!embed) return;
    const onMsg = (e: MessageEvent) => {
      if ((e.data as { type?: string })?.type === "towndesk:request-close") {
        window.parent.postMessage({ type: "towndesk:close-check", dirty }, "*");
      }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [embed, dirty]);
}
